import { Box, Button, Text } from "../../../../components";
import React from "react";

type FooterProps = {
  description: string;
  buttonText: string;
  onButtonClick: () => void;
};

export const LivenessModalFooter = ({
  description,
  buttonText,
  onButtonClick,
}: FooterProps) => {
  return (
    <Box flex flexDirectionColumn width100 alignCenter>
      <Text fontSize="medium" marginBottomS>
        {description}
      </Text>
      <Button secondary onClick={onButtonClick}>
        {buttonText}
      </Button>
    </Box>
  );
};
